import React from 'react';
import { makeStyles, withStyles } from '@material-ui/core/styles';
import Grid from '@material-ui/core/Grid';
import Button from '@material-ui/core/Button';
import TextField from '@material-ui/core/TextField';
import FormControl from '@material-ui/core/FormControl';
import FormGroup from '@material-ui/core/FormGroup';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import FormLabel from '@material-ui/core/FormLabel';
import Checkbox from '@material-ui/core/Checkbox';
import Dialog from '@material-ui/core/Dialog';
import AppBar from '@material-ui/core/AppBar';
import Toolbar from '@material-ui/core/Toolbar';
import IconButton from '@material-ui/core/IconButton';
import CloseIcon from '@material-ui/icons/Close';
import ExpansionPanel from '@material-ui/core/ExpansionPanel';
import ExpansionPanelSummary from '@material-ui/core/ExpansionPanelSummary';
import ExpansionPanelDetails from '@material-ui/core/ExpansionPanelDetails';
import Typography from '@material-ui/core/Typography';
import ExpandMoreIcon from '@material-ui/icons/ExpandMore';
import FilterListIcon from '@material-ui/icons/FilterList';

// Like https://github.com/brunobertolini/styled-by
const styledBy = (property, mapping) => (props) => mapping[props[property]];

const styles = {
  root: {
    background: styledBy('color', {
      teal: '#159587',
    }),
    borderRadius: 3,
    border: 0,
    color: 'white',
    height: 48,
    padding: '0 30px',
    boxShadow: styledBy('color', {
      default: '0 3px 5px 2px rgba(255, 105, 135, .3)',
      blue: '0 3px 5px 2px rgba(33, 203, 243, .3)',
    }),
    fontSize: '0.9em',
    overflow: 'hidden',
    whiteSpace: 'nowrap',
  },
};

const StyledButton = withStyles(styles)(({ classes, color, ...other }) => (
  <Button className={classes.root} {...other} />
));

export const FILTER_SECTION = {
  MOBILE: 'mobile',
  DESKTOP: 'desktop',
}

const useStyles = makeStyles((theme) => ({
  logoImg: {
    width: '100%',
    maxWidth: '375px',
  },
  appBar: {
    position: 'relative',
  },
  listImg: {
    width: '100%',
  },
  sortButton: {
    width: '20px',
    height: '20px',
  },
  hidden: {
    display: 'none',
  },
  filterPanel: {
    marginTop: '10px',
  }

}));

export default function Filter(props) {
  const classes = useStyles();
  const marketState = props.marketState;
  const setMarketState = props.setMarketState;
  const filterSection = props.filterSection;
  const setLoading = props.setLoading;
  const [searchKeyword, setSearchKeyword] = React.useState('');
  const [selectedCategories, setSelectedCategories] = React.useState([]);
  const [selectedLocations, setSelectedLocations] = React.useState([]);
  const [selectedRecommendations, setSelectedRecommendations] = React.useState([]);
  const [open, setOpen] = React.useState(false);

  //let timer;

  const filterByAttribute = (selectedAttributes, merchantAttributes) => {
    if (merchantAttributes !== undefined && merchantAttributes.length > 0) {
      return JSON.parse(merchantAttributes).some(x => selectedAttributes.find(y => y.toUpperCase() === x.toUpperCase()) !== undefined);
    }
  };

  const filterMerchants = () => {
    setLoading(true);
    //console.log(e);
    let filteredMerchants = [];
    const regexByKeyword = new RegExp(searchKeyword, "i")
    const filteredMerchantsByKeyword = marketState.initialMerchants.filter((merchant) => {
      return regexByKeyword.test(merchant.name);
    });

    filteredMerchants = filteredMerchantsByKeyword;

    if (selectedCategories.length > 0) {
      const filteredMerchantsByCategory = marketState.initialMerchants.filter((merchant) => {
        return filterByAttribute(selectedCategories, merchant.categories);
      });
      filteredMerchants = filteredMerchants.filter(m => filteredMerchantsByCategory.includes(m));
    }

    if (selectedLocations.length > 0) {
      const filteredMerchantsByLocations = marketState.initialMerchants.filter((merchant) => {
        return filterByAttribute(selectedLocations, merchant.locations);
      });
      filteredMerchants = filteredMerchants.filter(m => filteredMerchantsByLocations.includes(m));
    }

    if (selectedRecommendations.length > 0) {
      const filteredMerchantsByRecommendations = marketState.initialMerchants.filter((merchant) => {
        return filterByAttribute(selectedRecommendations, merchant.recommendations);
      });
      filteredMerchants = filteredMerchants.filter(m => filteredMerchantsByRecommendations.includes(m));
    }

    setMarketState((prevState) => {
      return { ...prevState, merchants: filteredMerchants, isFirstLoad: false };
    })

    if (filterSection === FILTER_SECTION.MOBILE) {
      handleClose();
    }
    setLoading(false);
  };

  // We put a delay here so it the setState won't be called everytime user type a character
  const handleKeywordChange = (keyword) => {
    //clearTimeout(timer);
    //timer = setTimeout(function () {
    //  setSearchKeyword(keyword);
    //}, 1000);
    setSearchKeyword(keyword);
  };

  const handleCategoriesChange = (cat) => {
    const catName = cat.name;
    const catIndex = selectedCategories.indexOf(catName);
    let filteredCategories = selectedCategories.slice();

    if (cat.checked && catIndex < 0) {
      // If there is no existing cat add it
      filteredCategories.push(catName);
    } else if (!cat.checked && catIndex >= 0) {
      // If there is existing cat remove it
      filteredCategories.splice(catIndex, 1);
    }

    setSelectedCategories(filteredCategories);
  };

  const handleLocationsChange = (loc) => {
    const locName = loc.name;
    const locIndex = selectedLocations.indexOf(locName);
    let filteredLocations = selectedLocations.slice();

    if (loc.checked && locIndex < 0) {
      // If there is no existing cat add it
      filteredLocations.push(locName);
    } else if (!loc.checked && locIndex >= 0) {
      // If there is existing cat remove it
      filteredLocations.splice(locIndex, 1);
    }

    setSelectedLocations(filteredLocations);
  };

  const handleRecommendationsChange = (rec) => {
    const recName = rec.name;
    const recIndex = selectedRecommendations.indexOf(recName);
    let filteredRecommendations = selectedRecommendations.slice();

    if (rec.checked && recIndex < 0) {
      // If there is no existing cat add it
      filteredRecommendations.push(recName);
    } else if (!rec.checked && recIndex >= 0) {
      // If there is existing cat remove it
      filteredRecommendations.splice(recIndex, 1);
    }

    setSelectedRecommendations(filteredRecommendations);
  };

  const handleClickOpen = () => {
    setOpen(true);
  };

  const handleClose = () => {
    setOpen(false);
  };

  // useEffect(() => {
  //   filterMerchants();
  // }, [searchKeyword, selectedCategories, selectedLocations, selectedRecommendations]);

  const switchSection = (filterSection) => {
    switch (filterSection) {
      case FILTER_SECTION.MOBILE:
        return (
          <Grid item xs={12} className="merchant-filter">
            <Button variant="outlined" size="large" onClick={handleClickOpen} fullWidth>
              <FilterListIcon /> {' '} FILTER
            </Button>
            <Dialog fullScreen open="true" onClose={handleClose} className={open ? "" : classes.hidden}>
              <AppBar className={classes.appBar}>
                <Toolbar>
                  <IconButton edge="start" color="inherit" onClick={handleClose} aria-label="close">
                    <CloseIcon />
                  </IconButton>
                  <Typography variant="h6">
                    FILTER
                  </Typography>
                </Toolbar>
              </AppBar>
              <div className="filter-box-mobile">
                <Grid container spacing={2}>
                  <Grid item xs={12}>
                    {/* <TextField variant="filled" id="standard-search" label="Find Restaurants" type="search" onChange={(e) => setSearchKeyword(e.target.value)} /> */}
                    <TextField fullWidth variant="filled" id="standard-search" label="Find Restaurants" type="search" onChange={(e) => handleKeywordChange(e.target.value)} />
                  </Grid>
                  <Grid item container xs={12} spacing={1}>
                    <FormControl componenet="fieldset" fullWidth>
                      <FormLabel component="legend">Categories: </FormLabel>
                      <FormGroup row>
                        {marketState.settings.categories && marketState.settings.categories.length > 0 && JSON.parse(marketState.settings.categories).map((cat) => {
                          return (
                            <Grid item xs={6}>
                              <FormControlLabel control={<Checkbox
                                onChange={(e) => handleCategoriesChange(e.target)} name={cat} size="medium" />} label={cat} />
                            </Grid>
                          )
                        })}
                      </FormGroup>
                    </FormControl>
                  </Grid>
                  <Grid item container xs={12} spacing={1}>
                    <FormControl componenet="fieldset" fullWidth>
                      <FormLabel component="legend">Locations: </FormLabel>
                      <FormGroup row>
                        {marketState.settings.locations && marketState.settings.locations.length > 0 && JSON.parse(marketState.settings.locations).map((loc) => {
                          return (
                            <Grid item xs={6}>
                              <FormControlLabel control={<Checkbox
                                onChange={(e) => handleLocationsChange(e.target)} name={loc} size="medium" />} label={loc} />
                            </Grid>
                          )
                        })}
                      </FormGroup>
                    </FormControl>
                  </Grid>
                  <Grid item container xs={12} spacing={1}>
                    <FormControl componenet="fieldset" fullWidth>
                      <FormLabel component="legend">Our Recommendations: </FormLabel>
                      <FormGroup row>
                        {marketState.settings.recommendations && marketState.settings.recommendations.length > 0 && JSON.parse(marketState.settings.recommendations).map((rec) => {
                          return (
                            <Grid item xs={6}>
                              <FormControlLabel control={<Checkbox
                                onChange={(e) => handleRecommendationsChange(e.target)} name={rec} size="medium" />} label={rec} />
                            </Grid>
                          )
                        })}
                      </FormGroup>
                    </FormControl>
                  </Grid>
                  <Grid item xs={12}>
                    <Button variant="contained" color="primary" disableElevation onClick={filterMerchants} fullWidth>
                      Filter
                    </Button>
                  </Grid>
                </Grid>
              </div>
            </Dialog>
          </Grid>
        )
      case FILTER_SECTION.DESKTOP:
      default:
        return (
          <Grid item xs={12} className="merchant-filter">
            <ExpansionPanel className={classes.filterPanel} fullWidth variant="outlined">
              <ExpansionPanelSummary
                expandIcon={<ExpandMoreIcon />}
                aria-controls="panel1a-content"
                id="panel1a-header"
              >
                <FilterListIcon />
                &nbsp;
                <Typography>
                  FILTER
                </Typography>
              </ExpansionPanelSummary>
              <ExpansionPanelDetails>
                <Grid container spacing={2}>
                  <Grid item xs={12}>
                    {/* <TextField variant="filled" id="standard-search" label="Find Restaurants" type="search" onChange={(e) => setSearchKeyword(e.target.value)} /> */}
                    <TextField fullWidth variant="filled" id="standard-search" label="Find Restaurants" type="search" onChange={(e) => handleKeywordChange(e.target.value)} />
                  </Grid>
                  <Grid container item xs={12} md={4} spacing={1}>
                    <FormControl componenet="fieldset">
                      <FormLabel component="legend">Categories: </FormLabel>
                      <FormGroup row>
                        {marketState.settings.categories && marketState.settings.categories.length > 0 && JSON.parse(marketState.settings.categories).map((cat) => {
                          return (
                            <Grid item xs={6}>
                              <FormControlLabel control={<Checkbox
                                onChange={(e) => handleCategoriesChange(e.target)} name={cat} size="small" />} label={cat} />
                            </Grid>
                          )
                        })}
                      </FormGroup>
                    </FormControl>
                  </Grid>
                  <Grid container item xs={12} md={4} spacing={1}>
                    <FormControl componenet="fieldset">
                      <FormLabel component="legend">Locations: </FormLabel>
                      <FormGroup row>
                        {marketState.settings.locations && marketState.settings.locations.length > 0 && JSON.parse(marketState.settings.locations).map((loc) => {
                          return (
                            <Grid item xs={6}>
                              <FormControlLabel control={<Checkbox
                                onChange={(e) => handleLocationsChange(e.target)} name={loc} size="small" />} label={loc} />
                            </Grid>
                          )
                        })}
                      </FormGroup>
                    </FormControl>
                  </Grid>
                  <Grid container item xs={12} md={4} spacing={1}>
                    <FormControl componenet="fieldset">
                      <FormLabel component="legend">Our Recommendations: </FormLabel>
                      <FormGroup row>
                        {marketState.settings.recommendations && marketState.settings.recommendations.length > 0 && JSON.parse(marketState.settings.recommendations).map((rec) => {
                          return (
                            <Grid item xs={6}>
                              <FormControlLabel control={<Checkbox
                                onChange={(e) => handleRecommendationsChange(e.target)} name={rec} size="small" />} label={rec} />
                            </Grid>
                          )
                        })}
                      </FormGroup>
                    </FormControl>
                  </Grid>
                  <Grid item xs={12}>
                    <StyledButton variant="contained" color="teal" disableElevation onClick={filterMerchants} fullWidth>
                      Search
                    </StyledButton>
                  </Grid>
                </Grid>
              </ExpansionPanelDetails>
            </ExpansionPanel>
          </Grid>
        )
    }
  };

  return (
    switchSection(filterSection)
  )
}